import {AppConfig} from 'appConfig';
import {defaultsDeep} from 'lodash-es';
import dexClientConfig from './dex-client';

const API_ROOT_HOST = 'dex.go.digital';

const appConfigPartial: Partial<AppConfig> = {
    env: 'dex-ci-client',

    /**
     * @type {ApiConfig}
     */
    api: {
        root: `https://${API_ROOT_HOST}/client-frontend`,

        testTokenAllocation: './api/fund'
    },

    localStorageKeyPrefix: 'dex-ci/v1/client'
};

export const dexCiClientConfig: AppConfig = defaultsDeep(appConfigPartial, dexClientConfig);
export default dexCiClientConfig;
